import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from "@angular/router";
import { AlertController, LoadingController } from '@ionic/angular';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  isLoading: boolean = false;

  constructor(
    private router: Router,
    public alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private navCtrl: NavController,
  ) { }

  previous() {
    this.navCtrl.back();
  }

  navigate(link: string, extras?: NavigationExtras) {
    return this.router.navigate([link], extras);
  }

  navigateByUrl(link: string, root: boolean = false) {
    if (root) {
      this.navCtrl.setDirection('root');
    }
    this.router.navigateByUrl(link);
  }

  backPage() {
    this.navCtrl.back();
  }

  validateEmail(email: string) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  numberFormat(value) {
    value = value + ''; // make sure it's a string
    if (value == undefined || value == '') {
      return '0';
    }
    return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  async showLoading(message: string) {
    this.isLoading = true;
    return await this.loadingCtrl.create({
      spinner: 'crescent',
      message: message,
      cssClass: 'loading-dark'
    }).then(a => {
      a.present().then(() => {
        // console.log('presented');
        if (!this.isLoading) {
          a.dismiss().then(() => console.log('abort presenting'));
        }
      });
    });
  }

  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '');
  }

  async closeLoading(message: any, title: string = 'Alerta!', type: string = 'alert') {
    this.isLoading = false;
    //console.log(message);
    let errors: string = '';
    if (message !== null) {
      if (message.status == 0) {
        errors = 'Ocurrio un error. Por favor vuelve a internarlo.';
      } else if (message.name == 'TimeoutError') {
        errors = 'Ocurrio un error, aparecer la conexión a internet esta fallando. Por favor vuelve a internarlo.';
      } else {
        const cadena = JSON.stringify(message.error);
        errors = this.escapeRegExp(cadena);
      }
    }

    return await this.loadingCtrl.dismiss(null, 'cancel').then(() => {
      if (message !== null) {
        switch (type) {
          case 'toastIn':
            this.showAlert(errors);
            break;
          case 'alert':
            this.showAlert(errors, title);
            break;
          default:
            this.showAlert(errors);
            break;
        }
      }
    }).catch(() => { });
  }

  async showAlert(message: string, title: string = 'Alerta!') {
    const alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: ['CERRAR'],
      backdropDismiss: false,
      cssClass: 'alert-dark'
    });
    await alert.present();
  }

  trackView(page: any) {

  }

  decimalAdjust(type: any, value: any, exp: any) {
    // Si el exp no está definido o es cero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // Si el valor no es un número o el exp no es un entero...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

}
